module.exports = __webpack_public_path__ + "static/img/icon-authorise.2d23bb6a.png";